'use client'

import cx from 'classnames'
import React, { CSSProperties } from 'react'
import { useInView } from 'react-intersection-observer'

export type AnimationChildrenProps = {
  animationRef?: React.Ref<HTMLDivElement>
  className?: string
  style?: CSSProperties
}
export type AnimationChildrenType = (_: AnimationChildrenProps) => React.ReactNode
export default function Animation({
  targetComponent,
  rootMargin,
  animationClassName,
  triggerOnce = true,
  invisible = false,
  isTransparent = false,
  animationDuration,
  delay = 0,
}: {
  targetComponent: AnimationChildrenType
  rootMargin: string
  animationClassName: string
  triggerOnce?: boolean
  invisible?: boolean
  isTransparent?: boolean
  animationDuration?: string
  delay?: number
}) {
  const { ref, inView } = useInView({
    threshold: 0,
    rootMargin,
    triggerOnce,
  })

  return (
    <>
      {targetComponent({
        animationRef: ref,
        className: cx({ invisible: invisible, [animationClassName]: inView }),
        style: {
          animationDuration: animationDuration,
          ...(isTransparent ? { opacity: 0 } : {}),
          ...(delay === 0 ? {} : { transitionDelay: `${delay}ms`, animationDelay: `${delay}ms` }),
        },
      })}
    </>
  )
}
